import React from 'react';

interface IconCaretProps {
    iconClasses?: string;
}

const IconCaret: React.FC<IconCaretProps> = ({ iconClasses }) => {
    return (
        <svg
            width="9"
            height="5"
            viewBox="0 0 9 5"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`icon icon-caret ${iconClasses ?? ''}`}
        >
            <path d="M4.40375 4.40375L0 0H8.8075L4.40375 4.40375Z" fill="currentColor" />
        </svg>
    );
};

export default IconCaret;
